export default __webpack_public_path__ + "static/media/ded-tools-notion.d14f1fc8.svg";